import React, { createContext, ReactNode, useContext } from 'react';

import { REGIONS } from '../types/index';

type NavContextType = {
  locale: string;
  region: REGIONS;
};

const NavContext = createContext<NavContextType>({
  locale: 'en',
  region: REGIONS.US,
});

export const NavProvider = ({
  children,
  locale = 'en',
  region = REGIONS.US,
}: {
  children: ReactNode;
  locale?: string;
  region?: REGIONS;
}) => {
  return (
    <NavContext.Provider value={{ locale, region }}>
      {children}
    </NavContext.Provider>
  );
};

export const useNavContext = () => useContext(NavContext);
